query StreamsListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: ContentsFilterInput
) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      totalViews
      createdAt
      deletedAt
      preview {
        id
        url(format: SMALL)
      }
      platform {
        id
        title
      }
      stream {
        id
        status
        liveConnected
        startAt
      }
    }
  }
}
